import type { IconSvgObject } from './types';

const TorusIcon: IconSvgObject = [
  ["ellipse", { cx: "12", cy: "12", rx: "10", ry: "8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TorusIcon;
